import { MenuCodes } from '../../../constants';
import Home from '../../../components/dashboard/home';
import Reports from '../../../components/dashboard/reports';
import ActivateAccount from '../../../components/dashboard/activate-account';
import EmailValidation from '../../../components/dashboard/email-validation';
import PaymentMethods from '../../../components/dashboard/payment-methods';
import Movements from '../../../components/dashboard/movements';
import Charges from '../../../components/dashboard/charges';
import Transactions from '../../../components/dashboard/transactions';
import TransactionDetail from '../../../components/dashboard/transactions/detail';
import TransactionAffiliations from '../../../components/dashboard/transactions/affiliations';
import TransactionsStatement from '../../../components/dashboard/transactions/statement';
import RefundDetail from '../../../components/dashboard/refunds/detail';
import Payouts from '../../../components/dashboard/payouts/index';
import Settlements from '../../../components/dashboard/settlements';
import CreatePaymentLink from '../../../components/dashboard/payment-link/create';
import CreatedPaymentLinks from '../../../components/dashboard/payment-link/created';
import CheckoutThemes from '../../../components/dashboard/checkout-themes';
import PaymentButton from '../../../components/dashboard/payment-button';
import PaymentIntegration from '../../../components/dashboard/payment-integration';
import CompanyInformation from '../../../components/dashboard/company-information';
import Refunds from '../../../components/dashboard/refunds/index';
import Clients from '../../../components/dashboard/clients';
import ClientDetailPage from '../../../components/dashboard/clients/detail';
import BankAccounts from '../../../components/dashboard/bank-accounts';
import Subscriptions from '../../../components/dashboard/subscriptions';
import SubscriptionsDetail from '../../../components/dashboard/subscriptions/subscribers/details';
import SubscriptionsPlanDetails from '../../../components/dashboard/subscriptions/plans/details';
import SubscriptionsCreateEditPlan from '../../../components/dashboard/subscriptions/plans/create-edit';
import Chargebacks from '../../../components/dashboard/chargebacks';
import ReviewDocumentation from '../../../components/dashboard/company-information/review-documentation';
import SplitPayments from '../../../components/dashboard/split-payments';
import SplitPaymentsUserType from '../../../components/dashboard/split-payments/create-steps/user-type';
import SplitPaymentsInformation from '../../../components/dashboard/split-payments/create-steps/collaboration-information';
import SplitPaymentsResume from '../../../components/dashboard/split-payments/create-steps/resume';
import SplitPaymentsSingleResume from '../../../components/dashboard/split-payments/resume';
import PayoutsAccountData from '../../../components/dashboard/payouts/create-steps/account-data';
import PayoutsPayoutData from '../../../components/dashboard/payouts/create-steps/payout-data';
import PayoutsReview from '../../../components/dashboard/payouts/create-steps/review';
import Marketing from '../../../components/dashboard/marketing';
import UserManagement from '../../../components/dashboard/user-management';
import ProfileAccountPage from '../../../components/dashboard/profile/profile-account-page';

export default {
  [MenuCodes.HOME]: <Home />,
  [MenuCodes.REPORTS]: <Reports />,
  [MenuCodes.ACTIVATE_ACCOUNT]: <ActivateAccount />,
  [MenuCodes.EMAIL_VALIDATION]: <EmailValidation />,
  [MenuCodes.PAYMENT_METHODS]: <PaymentMethods />,
  [MenuCodes.RENTABILITY_COVERAGE]: <PaymentMethods />,
  [MenuCodes.RENTABILITY_CALCULATOR]: <PaymentMethods />,
  [MenuCodes.RENTABILITY_ACCREDITATION_TIMES]: <PaymentMethods />,
  [MenuCodes.RENTABILITY_INSTALLMENTS]: <PaymentMethods />,
  [MenuCodes.MOVEMENTS]: <Movements />,
  [MenuCodes.CHARGES]: <Charges />,
  [MenuCodes.TRANSACTIONS]: <Transactions />,
  [MenuCodes.TRANSACTION_DETAIL]: <TransactionDetail />,
  [MenuCodes.TRANSACTIONS_AFFILIATIONS]: <TransactionAffiliations />,
  [MenuCodes.TRANSACTIONS_STATEMENT]: <TransactionsStatement />,
  [MenuCodes.REFUND_DETAIL]: <RefundDetail />,
  [MenuCodes.SETTLEMENTS]: <Settlements />,
  [MenuCodes.CREATE_ONE_TIME_PAYMENT_LINK]: <CreatePaymentLink />,
  [MenuCodes.CREATE_RECURRING_PAYMENT_LINK]: <CreatePaymentLink isRecurring />,
  [MenuCodes.CREATED_PAYMENT_LINKS]: <CreatedPaymentLinks />,
  [MenuCodes.CHECKOUT_THEMES]: <CheckoutThemes />,
  [MenuCodes.MARKETING]: <Marketing />,
  [MenuCodes.MARKETING_CAMPAIGNS]: <Marketing />,
  [MenuCodes.PAYMENT_BUTTON]: <PaymentButton />,
  [MenuCodes.PAYMENT_INTEGRATION]: <PaymentIntegration />,
  [MenuCodes.PAYMENT_INTEGRATION_API]: <PaymentIntegration />,
  [MenuCodes.COMPANY_INFORMATION]: <CompanyInformation />,
  [MenuCodes.REVIEW_DOCUMENTATION]: <ReviewDocumentation />,
  [MenuCodes.REFUNDS]: <Refunds />,
  [MenuCodes.PAYOUTS]: <Payouts />,
  [MenuCodes.PAYOUTS_STEP_ACCOUNT_DATA]: <PayoutsAccountData />,
  [MenuCodes.PAYOUTS_STEP_PAYOUT_DATA]: <PayoutsPayoutData />,
  [MenuCodes.PAYOUTS_STEP_REVIEW]: <PayoutsReview />,

  [MenuCodes.CLIENTS]: <Clients />,
  [MenuCodes.CLIENT_DETAIL]: <ClientDetailPage />,
  [MenuCodes.BANK_ACCOUNTS]: <BankAccounts />,
  [MenuCodes.CHARGEBACKS]: <Chargebacks />,
  [MenuCodes.SUBSCRIPTIONS]: <Subscriptions initTabSelected={0} />,
  [MenuCodes.SUBSCRIPTIONS_PLANS]: <Subscriptions initTabSelected={1} />,
  [MenuCodes.SUBSCRIPTIONS_DETAIL]: <SubscriptionsDetail />,
  [MenuCodes.SUBSCRIPTIONS_PLANS_DETAILS]: <SubscriptionsPlanDetails />,
  [MenuCodes.SUBSCRIPTIONS_PLANS_CREATE]: <SubscriptionsCreateEditPlan />,
  [MenuCodes.SUBSCRIPTIONS_PLANS_EDIT]: <SubscriptionsCreateEditPlan />,
  [MenuCodes.SPLIT_PAYMENTS]: <SplitPayments />,
  [MenuCodes.SPLIT_PAYMENTS_RESUME]: <SplitPaymentsSingleResume />,
  [MenuCodes.SPLIT_PAYMENTS_STEP_USER_TYPE]: <SplitPaymentsUserType />,
  [MenuCodes.SPLIT_PAYMENTS_STEP_INFORMATION]: <SplitPaymentsInformation />,
  [MenuCodes.SPLIT_PAYMENTS_STEP_RESUME]: <SplitPaymentsResume />,
  [MenuCodes.USER_MANAGEMENT]: <UserManagement />,
  [MenuCodes.SIDEBAR_PROFILE]: <ProfileAccountPage />,
};
